/**
 * @generated SignedSource<<099c597e7219eca9fb6157a3a6e874ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIGenerationStatus = "completed" | "draft" | "failed" | "pending" | "running" | "%future added value";
export type ContentType = "assignment" | "assignment_submission" | "attachment" | "comment" | "confirmation" | "custom" | "embed" | "module" | "occurrence" | "post" | "quiz" | "survey" | "text" | "video" | "%future added value";
export type ResumeAIGenerationInput = {
  acceptedMessageId?: string | null;
  curriculumModules?: ReadonlyArray<AIGenerationCurriculumModuleInput> | null;
  id: string;
  includeWelcomeModule?: boolean | null;
  prompt?: string | null;
  promptContentIndex?: number | null;
  promptModuleIndex?: number | null;
  referenceEmbeddingSourceIds?: ReadonlyArray<string> | null;
  referenceUrl?: string | null;
  searchWeb?: boolean | null;
  uploadedAssetIds?: ReadonlyArray<string> | null;
};
export type AIGenerationCurriculumModuleInput = {
  content: ReadonlyArray<AIGenerationCurriculumContentInput>;
  title: string;
};
export type AIGenerationCurriculumContentInput = {
  summary: string;
  title: string;
  type: ContentType;
};
export type AICanvasDrawerContentMutation$variables = {
  input: ResumeAIGenerationInput;
};
export type AICanvasDrawerContentMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly acceptedMessageId: string | null;
      readonly status: AIGenerationStatus;
    } | null;
  };
};
export type AICanvasDrawerContentMutation = {
  response: AICanvasDrawerContentMutation$data;
  variables: AICanvasDrawerContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "acceptedMessageId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AICanvasDrawerContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "ResumeAIGenerationResponse",
        "kind": "LinkedField",
        "name": "resumeAIGeneration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AIGeneration",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AICanvasDrawerContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "ResumeAIGenerationResponse",
        "kind": "LinkedField",
        "name": "resumeAIGeneration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AIGeneration",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "943fc4dd2af8fc0f7529bdb279a8230c",
    "id": null,
    "metadata": {},
    "name": "AICanvasDrawerContentMutation",
    "operationKind": "mutation",
    "text": "mutation AICanvasDrawerContentMutation(\n  $input: ResumeAIGenerationInput!\n) {\n  response: resumeAIGeneration(input: $input) {\n    node {\n      status\n      acceptedMessageId\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fdea047265f3e4f743db58ab9251dc34";

export default node;
